export default __webpack_public_path__ + "static/media/icon_fotografias_selected.690c26cf.svg";